<div class="box">
    <h2 class="fs-19 fs-lg-24 fw-700 mb-1 mb-lg-2">
        @if (partner.address.place) {
            {{ partner.address.place }}
        } @else {
            {{ partner.address.city }}
        }
    </h2>
    <div class="lh-1 mb-3">
        <span class="text-gray-300 fs-12 lh-1"> {{ partner.address.street }}, {{ partner.address.postalCode }} {{ partner.address.city }}</span>
    </div>
    @if (partner.www.length > 0) {
        <div class="lh-1 mb-1">
            @for (www of partner.www; track www; let last = $last) {
                <a [href]="www" class="d-block mb-1 fs-12">{{ www }}</a>
            }
        </div>
    }
    @if (partner.emails.length > 0) {
        <div class="lh-1 mb-1">
            @for (email of partner.emails; track email; let last = $last) {
                <a href="mailto:{{ email }}" class="fs-12">{{ email }}</a>
                @if (!last) {
                    <span class="text-gray-300 fs-12">, </span>
                }
            }
        </div>
    }
    @if (partner.phones.length > 0) {
        <div class="lh-1 mb-1">
            @for (phone of partner.phones; track phone; let last = $last) {
                <a [href]="'tel:' + formatPhoneForTel(phone)" class="fs-12">{{ phone }}</a>
                @if (!last) {
                    <span class="text-gray-300 fs-12">, </span>
                }
            }
        </div>
    }
    @if (partner.socials) {
        <div class="mt-2 fs-12">
            @if (partner.socials.facebook) {
                <a target="_blank" [href]="partner.socials.facebook" class="d-block mb-1">
                    {{ partner.socials.facebook }}
                </a>
            }
            @if (partner.socials.instagram) {
                <a target="_blank" [href]="partner.socials.instagram" class="d-block mb-1">
                    {{ partner.socials.instagram }}
                </a>
            }
        </div>
    }
</div>
